// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M2 2H22V22H2V2ZM4 4V20H20V4H4ZM8 6.37083L17.75 12L8 17.6292L8 6.37083ZM10 9.83494L10 14.1651L13.75 12L10 9.83494Z"}}]};

const VideoIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video',
    ref,
    icon: element,
  },
));

VideoIcon.displayName = 'VideoIcon';

export default VideoIcon;
